import { Typography } from '@/components/common';
import { PageContainer, SimpleBanner } from '@/components/landing';

export const TermsOfUse = () => {
	return (
		<>
			<SimpleBanner
				text="Terms of Use"
				description={
					<div className="flex items-center gap-1">
						<Typography type="semibold-16" className="text-black">
							Effective date:{' '}
						</Typography>
						<Typography type="regular-16">09/02/2026</Typography>
					</div>
				}
			/>
			<PageContainer className="space-y-8 pb-16 lg:pb-[88px]">
				<Typography type="regular-16">
					Loch Brandy LLC, d/b/a Claim Magic owns and operates the website
					located at{' '}
					<a
						href="http://www.claimmagic.com"
						className="text-blue-link underline"
					>
						www.claimmagic.com
					</a>{' '}
					(&rdquo;Claim Magic&rdquo; or the &rdquo;Platform&rdquo;). Your access
					and use of the Platform, any part thereof, or anything associated
					therewith, including its content (&rdquo;Content&rdquo;), any products
					or services provided through the Platform or otherwise by Claim Magic,
					communications based on your use of the Platform, and any affiliated
					website, software or application owned or operated by Claim Magic
					(collectively, including the Platform, Content, and the
					&rdquo;Service&rdquo;) are governed by these Terms of Use
					(&rdquo;Terms of Use&rdquo; or &rdquo;Agreement&rdquo;).
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					1. Acceptance
				</Typography>
				<Typography type="regular-16">
					Please read these Terms of Use carefully because they set forth the
					important terms you will need to know. Your access to and use of Claim
					Magic is subject to this Agreement, as well as all applicable laws and
					regulations. If you do not accept and agree to be bound by this
					Agreement in its entirety, please leave this page immediately. By not
					accepting the Agreement, you are strictly prohibited from visiting,
					accessing, registering with and/or using the Service or any
					information or Content provided through the Service—except as
					necessary to review this Agreement. The Service is continually under
					development, and we reserve the right to revise or remove any part of
					this Agreement or the Service in our sole discretion at any time and
					without prior notice to you. Any changes to this Agreement are
					effective upon posting to the Platform. Unless otherwise indicated,
					any new Content added to the Service is also subject to this Agreement
					upon posting to the Platform. If you disagree with this Agreement or
					any terms or conditions herein, your sole remedy is to discontinue
					your use of the Service. Your continued use of the Service constitutes
					your acceptance of this Agreement, including any modifications.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					2. Anti-Fraud Validation
				</Typography>
				<Typography type="regular-16">
					You may be asked to provide certain information about yourself to
					facilitate obtaining legal representation through Claim Magic. This
					information must be accurate to ensure that lawyers reviewing your
					claims can evaluate them properly and comply with any related
					professional, legal, and ethical obligations. Accordingly, you are not
					permitted to use Claim Magic on behalf of other individuals, or under
					an alias, pseudonym, or identity other than your true legal identity
					(i.e., the one used on official government documents like a driver’s
					license), and you agree and give your consent that Claim Magic may use
					the information that you provide in your profile (including but not
					limited to your name, address, phone number, email address, and IP
					address) to validate that identity, including by using anti-fraud
					tools supplied by third party vendors.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					3. Agreement to Arbitrate
				</Typography>
				<Typography type="regular-16">
					You and Claim Magic agree that any dispute, claim, or controversy
					arising out of or relating to these Terms of Use, the Claim Magic
					platform, or your use of any services offered through Claim
					Magic—including any dispute about the validity, enforceability, or
					scope of this Arbitration Agreement—shall be resolved exclusively
					through binding arbitration, rather than in court, except as provided
					below.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					4. Arbitration Forum and Rules
				</Typography>
				<Typography type="regular-16">
					Arbitration shall be administered by JAMS pursuant to its applicable
					rules and procedures, including the JAMS Streamlined Arbitration Rules
					for claims under $250,000 and the JAMS Comprehensive Arbitration Rules
					for larger claims, which are available at{' '}
					<a href="http://www.jamsadr.com" className="text-blue-link underline">
						www.jamsadr.com
					</a>
					. The arbitrator shall have exclusive authority to resolve any dispute
					relating to the interpretation, applicability, or enforceability of
					this Arbitration Agreement. For the avoidance of any doubt, you shall
					be responsible for all filing, administrative, arbitrator, and other
					fees due to JAMS.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					5. Seat and Governing Law
				</Typography>
				<Typography type="regular-16">
					The arbitration shall be conducted in New York, New York, and shall be
					governed by and construed in accordance with the laws of the State of
					New York, without regard to its conflict of laws principles. The
					Federal Arbitration Act, 9 U.S.C. § 1 et seq., shall govern the
					interpretation and enforcement of this Arbitration Agreement.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					6. Informal Dispute Resolution
				</Typography>
				<Typography type="regular-16">
					Before initiating arbitration, you agree to first contact Claim Magic
					at{' '}
					<a
						href="mailto:info@claimmagic.com"
						className="text-blue-link underline"
					>
						info@claimmagic.com
					</a>{' '}
					and provide a written description of the dispute and any relief
					sought, your name, and contact information. The parties agree to
					attempt to resolve the dispute informally for a period of thirty (30)
					days from the date of the written notice. If the dispute is not
					resolved within that period, either party may commence arbitration.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					7. Waiver of Class Action and Jury Trial
				</Typography>
				<Typography type="regular-16">
					By agreeing to arbitration, you and Claim Magic each waive the right
					to a trial by jury and to participate in a class action lawsuit with
					respect to any dispute covered by this Arbitration Agreement. You
					understand that arbitration is a private process; that arbitration
					awards are generally final and binding and not subject to appeal on
					the merits; that discovery in arbitration is more limited than in
					court proceedings; and that you may be responsible for a portion of
					the arbitration costs. You have the right to consult with independent
					counsel before agreeing to these terms.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					8. Severability
				</Typography>
				<Typography type="regular-16">
					If any part of this Arbitration Agreement is found to be
					unenforceable, the remaining portions shall remain in full force and
					effect, except that if the Class Action Waiver is found unenforceable,
					the entire Arbitration Agreement shall be null and void.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					9. Opt-Out Right
				</Typography>
				<Typography type="regular-16">
					You may opt out of this Arbitration Agreement by sending written
					notice by email to{' '}
					<a
						href="mailto:info@claimmagic.com"
						className="text-blue-link underline"
					>
						info@claimmagic.com
					</a>{' '}
					within thirty (30) days of first accepting these Terms of Use. Your
					notice must include your name, email address, and a clear statement
					that you wish to opt out of arbitration. If you opt out, all disputes
					will be resolved in a court of competent jurisdiction in New York, New
					York, where you consent to jurisdiction.
				</Typography>

				<br />
				<Typography type="regular-16" className="text-purple-150 font-semibold">
					10. Assignment
				</Typography>
				<Typography type="regular-16">
					You may not assign any of your rights under this Agreement, and any
					such attempt will be null and void.
				</Typography>
			</PageContainer>
		</>
	);
};
